import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DepartmentsService } from './departments.service';
import { DepartmentsDTO } from './dto/departments.dto';
import { DepartmentResponseModel, AllDepartmentsResponseModel } from '@gtpl/shared-models/masters';
import { DepartmentRequest } from './dto/department.request';

@ApiTags('Departments')
@Controller('departments')
export class DepartmentsController {
    constructor(
        private departmentsService: DepartmentsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
   /**
     * creates or updates a value of department
     * @param departmentDto department DTO
     * @returns departmentResponse
     */
    @Post('/createDepartment')
    async createDepartment(@Body() departmentsDTO:DepartmentsDTO,isUpdate:boolean=false,@Req() request:Request): Promise<DepartmentResponseModel> {
        try {
            // console.log(departmentsDTO);
            return await this.departmentsService.createDepartment(departmentsDTO, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(DepartmentResponseModel, error)
        }
    }

    /**
     * creates or updates a value of department
     * @param departmentDto department DTO
     * @returns departmentResponse
     */
    @Post('/updateDepartment')
    async updateDepartment(@Body() departmentsDTO: DepartmentsDTO,@Req() request:Request): Promise<DepartmentResponseModel> {
        try {
        return await this.departmentsService.createDepartment(departmentsDTO, true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(DepartmentResponseModel, error)
        }
    }

      /**
     * gets all the Value of departments
     * @returns AllValue departmentsResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
    @Post('/getAllDepartments')
    async getAllDepartments(@Req() request: Request): Promise<AllDepartmentsResponseModel> {
        try {
        return await this.departmentsService.getAllDepartments();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllDepartmentsResponseModel, error)
        }
    }
    @Post('/getAllActiveDepartments')
  async getAllActiveDepartments(@Req() request: Request): Promise<AllDepartmentsResponseModel> {
      try {
          return await this.departmentsService.getAllActiveDepartments();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(AllDepartmentsResponseModel, error)
      }
  }

     /**
     * Activate Or De-Activate Value Department
     * @param getSingleDepartment DepartmentResponseModel 
     * @returns Value Department
     */
    @Post('/activateOrDeactivateDepartment')
    async activateOrDeactivateDepartment(@Body() departmentReq: DepartmentRequest): Promise<DepartmentResponseModel> {
        try {
            return await this.departmentsService.activateOrDeactivateDepartment(departmentReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(DepartmentResponseModel, err);
        }
    }

    @Post('/getDepartmentDataById')
    async getDeptDataById(@Body() deptReq: DepartmentRequest ): Promise<DepartmentResponseModel>{
        try{
            return await this.departmentsService.getDepartmentDataById(deptReq);
        }catch(err){
            return this.applicationExceptionhandler.returnException(DepartmentResponseModel, err);
        }
    }
    @Post('/getDepartmentNameByDeptIds')
    async getDepartmentNameByDeptIds(@Body() deptReq: number[]): Promise<AllDepartmentsResponseModel>{
        try{
            return await this.departmentsService.getDepartmentNameByDeptIds(deptReq);
        }catch(err){
            return this.applicationExceptionhandler.returnException(AllDepartmentsResponseModel, err);
        }
    }
}
